import type { ChangeEventHandler } from "react";

export function WaterInput({ id, label, value, placeholder, maxLength = 120, onChange, autoFocus = false, className = "" }: {
  id: string; label: string; value: string; placeholder: string; maxLength?: number;
  onChange: ChangeEventHandler<HTMLTextAreaElement>; autoFocus?: boolean; className?: string;
}) {
  return (
    <label className={"v2-water-input" + (className ? " " + className : "")} htmlFor={id}>
      <span>{label}</span>
      <textarea id={id} value={value} onChange={onChange} rows={2} maxLength={maxLength} placeholder={placeholder} autoFocus={autoFocus} />
    </label>
  );
}
